var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('w-top-bar',[_vm._v("Participante")]),_c('div',{staticClass:"p-5 bg-gray-200 h-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }